import store from '@/store';

export default function show() {
  store.dispatch('notificationDialog/setShow', { show: true });
}
